module.exports = __webpack_public_path__ + "static/media/jPolis.3c8080b2.jpeg";